import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from 'store';
import { Provider } from 'react-redux';
import {BrowserRouter} from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import './index.css';
import './fonts/Poppins/Poppins-Bold.ttf';
import './fonts/Poppins/Poppins-Regular.ttf';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter >
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
